import { isArray, isObject } from '../real-type-of';
export const flattenObject = (input, prefix = '', separator = '.', ignoreArrays = false) => {
    if (isObject(input) || (!ignoreArrays && isArray(input))) {
        return Object.entries(input).reduce((acc, [key, value]) => {
            const newKey = prefix ? `${prefix}${separator}${key}` : key;
            return {
                ...acc,
                ...flattenObject(value, newKey, separator, ignoreArrays)
            };
        }, {});
    }
    return { [prefix]: input };
};
//# sourceMappingURL=flatten.js.map